import React from 'react';
import ListSectionContent from '../../../shared/components/ListSectionContent';
import MedicationListSectionContent from './MedicationListSectionContent';
import Section from '../../../shared/components/Section';
import TimingSectionContent from './TimingSectionContent';
import NotesSectionContent from './NotesSectionContent';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { designConstants } from '../../../design/styles';
import FactorsListSectionContent from './FactorsListSectionContent';
import strings from '../strings';
import { SectionDrawer } from '../../../shared/components/SectionDrawer';
import SeveritySliderComponent from './SeveritySliderComponent';
import fieldsStrings from '../../Fields/strings';
import ListSectionCounter from '../../../shared/components/ListSectionCounter';
import SeveritySliderCounter from './SeveritySliderCounter';
import NotesSectionCounter from './NotesSectionCounter';
import MedicationListSectionCounter from './MedicationListSectionCounter';
import FactorsListSectionCounter from './FactorsListSectionCounter';
import TimingSectionCounter from './TimingSectionCounter';
import { withTheme } from '../../../design/styles/useThemeContext';

class RecordSectionDrawer extends React.Component {
  static propTypes = {
    scroll: PropTypes.node,
  };
  static defaultProps = {
    scrollOffset: 0,
  };

  state = {
    sliding: false,
  };

  bindScrollRef = (ref) => {
    this.scrollRef = ref;
    this.forceUpdate();
  };

  render() {
    const { colors } = this.props.theme;
    return (
      <SectionDrawer
        ref={this.bindRootRef}
        scrollRef={this.bindScrollRef}
        scrollEnabled={!this.state.sliding}
        navigation={this.props.navigation}
      >
        {designConstants.isTablet() && (
          <Section
            tag={'severity'}
            secondary={
              fieldsStrings.constants_severity_section_header_secondary
            }
            first
            scroll={this.scrollRef}
            counter={SeveritySliderCounter}
            severityMode={'PainRecord'}
            header={fieldsStrings.constants_severity_section_header}
          >
            <SeveritySliderComponent
              screen={'createRecord'}
              sliding={(sliding) => {
                this.setState({ sliding });
              }}
            />
          </Section>
        )}
        {!designConstants.isTablet() && (
          <View
            style={{
              backgroundColor: colors.defaultBackground,
              alignSelf: 'stretch',
              paddingBottom: designConstants.paddings.edgePadding,
            }}
          >
            <SeveritySliderComponent
              screen={'createRecord'}
              sliding={(sliding) => {
                this.setState({ sliding });
              }}
            />
          </View>
        )}
        <Section
          tag={'location'}
          secondary={
            strings.create_record_drawer_location_section_header_plural
          }
          first={!designConstants.isTablet()}
          scroll={this.scrollRef}
          counter={ListSectionCounter}
          header={
            strings.create_record_drawer_location_section_header_secondary
          }
        >
          <ListSectionContent
            navigation={this.props.navigation}
            field="location"
            checked={this.props.record}
          />
        </Section>
        <Section
          secondary={
            strings.create_record_drawer_symptoms_section_header_plural
          }
          counter={ListSectionCounter}
          tag={'symptom'}
          scroll={this.scrollRef}
          header={
            strings.create_record_drawer_symptoms_section_header_secondary
          }
        >
          <ListSectionContent
            field="symptom"
            navigation={this.props.navigation}
          />
        </Section>
        <Section
          secondary={
            strings.create_record_drawer_character_section_header_plural
          }
          counter={ListSectionCounter}
          tag={'character'}
          scroll={this.scrollRef}
          header={
            strings.create_record_drawer_character_section_header_secondary
          }
        >
          <ListSectionContent
            field="character"
            navigation={this.props.navigation}
          />
        </Section>
        <Section
          secondary={
            strings.create_record_drawer_aggravating_factors_section_header_plural
          }
          counter={ListSectionCounter}
          tag={'aggravating_factor'}
          scroll={this.scrollRef}
          header={
            strings.create_record_drawer_aggravating_factors_section_header_secondary
          }
        >
          <ListSectionContent
            field="aggravating_factor"
            navigation={this.props.navigation}
          />
        </Section>
        <Section
          tag={'medications'}
          scroll={this.scrollRef}
          counter={MedicationListSectionCounter}
          secondary={strings.create_record_drawer_medication_secondary_header}
          header={strings.create_record_drawer_medication_header}
        >
          <MedicationListSectionContent
            items={this.props.fields}
            navigation={this.props.navigation}
            onFieldChange={this.props.onFieldChange}
          />
        </Section>
        <Section
          isMedication={true}
          tag={'factors'}
          scroll={this.scrollRef}
          counter={FactorsListSectionCounter}
          secondary={strings.create_record_drawer_factors_secondary_header}
          header={strings.create_record_drawer_factors_header}
        >
          <FactorsListSectionContent
            items={this.props.fields}
            navigation={this.props.navigation}
            onFieldChange={this.props.onFieldChange}
          />
        </Section>
        <Section
          secondary={strings.create_record_drawer_timing_section_header}
          tag={'timing'}
          counter={TimingSectionCounter}
          scroll={this.scrollRef}
          header={strings.create_record_drawer_timing_section_header_secondary}
          onFieldChange={this.props.onFieldChange}
        >
          <TimingSectionContent />
        </Section>
        <Section
          secondary={
            strings.create_record_drawer_environment_section_header_plural
          }
          counter={ListSectionCounter}
          tag={'environment'}
          scroll={this.scrollRef}
          header={
            strings.create_record_drawer_environment_section_header_secondary
          }
        >
          <ListSectionContent
            field="environment"
            navigation={this.props.navigation}
          />
        </Section>
        <Section
          secondary={strings.create_record_drawer_notes_section_header}
          last
          tag={'notes'}
          scroll={this.scrollRef}
          counter={NotesSectionCounter}
          header={strings.create_record_drawer_notes_section_header_secondary}
          onFieldChange={this.props.onFieldChange}
        >
          <NotesSectionContent mode="painrecord" />
        </Section>
      </SectionDrawer>
    );
  }
}

export default withTheme(RecordSectionDrawer);
